// useTexts.js
import { ref, computed } from 'vue';
import api from "@/api/api";

const texts = ref([]);
const textsLoading = ref(false);
const textsLoaded = ref(false);

const fetchTexts = async (language) => {
    if (textsLoaded.value) {
        return;
    }
    textsLoading.value = true;
    try {
        const response = await api.get(`/texts/?lang=${language}`);
        texts.value = response.data;
        textsLoaded.value = true;
    } catch (error) {
        console.error('Error fetching texts:', error);
    } finally {
        textsLoading.value = false;
    }
};

const getTextsForComponent = (componentName) => {
    return computed(() => {
        return texts.value[componentName] || {};
    });
};

const replacePlaceholders = (str, placeholders) => {
    let result = str;
    for (const placeholder in placeholders) {
        result = result.replace(`\${${placeholder}}`, placeholders[placeholder]);
    }
    return result;
};

export default function useTexts() {
    return { fetchTexts, getTextsForComponent, replacePlaceholders, textsLoaded, textsLoading };
}
